import { request } from "../../httpClient";

export const createGalleryRequest = async (values) => {
  const res = await request({
    path: "vehicle-gallery/set",
    method: "POST",
    body: values,
    requestType: null,
  });
  return res;
};
